<template>
  <div class="form-label-pc">
    <div v-if="isRequired" style="color: red;">
      *&nbsp;
    </div>
    {{ name }}
  </div>
</template>
<script lang="ts">
  export default {
    props: {
      name: {
        type: String,
        default: ''
      },
      isRequired: {
        type: Number,
        default: 0
      }
    },
  }
</script>
<style lang="scss">
.form-label-pc {
  display:flex;
  padding-bottom: 8px;
  margin-top: 12px;
  overflow-wrap: break-word;
  word-break: normal;
}
</style>
